var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dropdown',{staticClass:"QHSelectBtn",attrs:{"placement":"bottom-end"}},[_c('Button',{attrs:{"type":"info","size":"small","icon":_vm.icon}},[_vm._v(_vm._s(_vm.title))]),_c('DropdownMenu',{staticClass:"DropdownMenu",attrs:{"slot":"list"},slot:"list"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }